import { ClassNamesConfig } from "react-select";
import { SEARCH_FIELDS } from "../../mappings";
import { MenuItem } from "../../../../components/@types";

export const MAX_BYTES_SIZE_NUMBER = 2147483647;

export const SEARCH_DEBOUNCE_TIME = 500;

export const AV_VENDORS = {
  Ahnlab: `${SEARCH_FIELDS.AHNLAB}*`,
  Antivir: `${SEARCH_FIELDS.ANTIVIR}*`,
  Avast: `${SEARCH_FIELDS.AVAST}*`,
  Bitdefender: `${SEARCH_FIELDS.BITDEFENDER}*`,
  CarbonBlack: `${SEARCH_FIELDS.CARBONBLACK}*`,
  ClamAV: `${SEARCH_FIELDS.CLAMAV}*`,
  CrowdStrike: `${SEARCH_FIELDS.CROWDSTRIKE}*`,
  "Dr.Web": `${SEARCH_FIELDS.DRWEB}*`,
  Endgame: `${SEARCH_FIELDS.ENDGAME}*`,
  Ffri: `${SEARCH_FIELDS.FFRI}*`,
  FireEye: `${SEARCH_FIELDS.FIREEYE}*`,
  Fortinet: `${SEARCH_FIELDS.FORTINET}*`,
  "G Data": `${SEARCH_FIELDS.GDATA}*`,
  Ikarus: `${SEARCH_FIELDS.IKARUS}*`,
  "K7 Computing": `${SEARCH_FIELDS.K7COMPUTING}*`,
  Malwarebytes: `${SEARCH_FIELDS.MALWAREBYTES}*`,
  McAfee: `${SEARCH_FIELDS.MCAFEE}*`,
  Microsoft: `${SEARCH_FIELDS.MICROSOFT}*`,
  Panda: `${SEARCH_FIELDS.PANDA}*`,
  "Quick Heal": `${SEARCH_FIELDS.QUICKHEAL}*`,
  Rising: `${SEARCH_FIELDS.RISING}*`,
  SentinelOne: `${SEARCH_FIELDS.SENTINELONE}*`,
  Sonicwall: `${SEARCH_FIELDS.SONICWALL}*`,
  Sophos: `${SEARCH_FIELDS.SOPHOS}*`,
  Symantec: `${SEARCH_FIELDS.SYMANTEC}*`,
  "Trend Micro": `${SEARCH_FIELDS.TRENDMICRO}*`,
  VBA32: `${SEARCH_FIELDS.VBA32}*`
};

export const CUSTOM_SELECT_CLASSNAMES: ClassNamesConfig<MenuItem> = {
  clearIndicator: () => `multiselect-clear-indicator`,
  control: () => `multiselect-control`,
  option: () => `multiselect-option`,
  valueContainer: () => `multiselect-value-container`,
  placeholder: () => `multiselect-placeholder`,
  dropdownIndicator: () => `multiselect-dropdown-indicator`,
  input: () => `multiselect-search-input`,
  indicatorSeparator: () => `multiselect-indicator-separator`
};

export const TEST_ID_KEYS = {
  FILE_NAME_OPTION: "fileNameOption",
  FILE_NAME: "fileName",
  FILE_TYPE: "fileType",
  FROM_SIZE_NUMBER: "fromSizeNumber",
  FROM_SIZE_TYPE: "fromSizeType",
  TO_SIZE_NUMBER: "toSizeNumber",
  TO_SIZE_TYPE: "toSizeType",
  ANTIVIRUS_DETECTIONS_COUNT_FROM: "antivirusDetectionsCountFrom",
  ANTIVIRUS_DETECTIONS_COUNT_TO: "antivirusDetectionsCountTo",
  FILE_TAGS: "fileTags",
  THREAT_NAME: "threatName",
  CLASSIFICATION: "classification",
  THREAT_SCORE: "threatScore",
  ATTACK_TECHNIQUE: "attackTechnique",
  STATIC_ANALYSIS_INDICATORS: "staticAnalysisIndicators",
  AV_VENDORS: "avVendors"
};
